var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('age-requirement',[_c('v-facebook-login',{attrs:{"app-id":_vm.app_id},on:{"click":function($event){_vm.clicked = true},"sdk-init":_vm.handleSdkInit,"login":_vm.getUserData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }